// Mock data extracted from https://eternia.greatvaluerealty.com/

export const brand = {
  greatValueLogo: "https://eternia.greatvaluerealty.com/assets/images/logo/great_value_dark.webp",
  yatharthLogo: "https://eternia.greatvaluerealty.com/assets/images/logo/yatharth_dark.webp",
  eterniaLogo: "https://eternia.greatvaluerealty.com/assets/images/hero/eternia_dark.png",
  phone: "+91-98181 45991",
  phoneRaw: "919818145991",
  location: "Tech Zone IV, Greater Noida (W)",
  mapUrl: "https://maps.app.goo.gl/D32ZWQt3iw6dFKDq5",
  sampleFlatTour: "https://nsventures.tech/Eternia_ShowAppartment360_V3/"
};

export const navLinks = [
  { label: "HOME", href: "#hero-section" },
  { label: "ABOUT US", href: "#overview-section" },
  { label: "HIGHLIGHTS", href: "#highlights-section" },
  { label: "PRICE LIST", href: "#price-list-section" },
  { label: "AMENITIES", href: "#amenities-section" },
  { label: "LOCATION", href: "#location-section" },
  { label: "FLOOR PLAN", href: "#floor-plans-section" },
  { label: "GALLERY", href: "#gallery-section" },
  { label: "CONTACT US", href: "#contact-us" }
];

export const hero = {
  leftImage: "https://eternia.greatvaluerealty.com/assets/images/hero/left.webp",
  multiFlowers: "https://eternia.greatvaluerealty.com/assets/images/hero/multi_flowers.png",
  locationIcon: "https://eternia.greatvaluerealty.com/assets/images/icons/location.png",
  location: "Tech Zone IV, Greater Noida (W)",
  title: "Spacious 3 & 4 BHK",
  titleAccent: "Residences for Grand Living",
  priceLabel: "price start from",
  price: "\u20B9 1.81 Cr*",
  offerText: "Offer Valid on Limited Units Only",
  offerBenefits: [
    "1 car parking",
    "club membership",
    "power backup",
    "electricity infrastructure charges",
    "2 year maintenance"
  ]
};

export const overview = {
  bg: "https://eternia.greatvaluerealty.com/assets/images/overview/bg.webp",
  flower: "https://eternia.greatvaluerealty.com/assets/images/flower1.png",
  eyebrow: "About Us",
  title: "Rooted in Grace. Defined by Design.",
  desc: "Eternia draws its inspiration from the Anthurium flower\u2014a symbol of timeless life, quiet strength, and graceful permanence. Located on a wide 130-meter road in the most prime, fully habitable sector of Greater Noida West, this non-congested oasis faces a 100-meter wide developed green belt. Spread across 6 beautifully laid-out acres with 6 G+30 skyline-defining towers, Eternia is a celebration of space, symmetry, and sensibility. With 4 lifts per tower and intelligently planned layouts, the project offers lesser saleable area and more usable space\u2014delivering unmatched value. Here, beauty meets function and space meets soul.",
  stats: [
    { value: 6, suffix: "", label: "Acres" },
    { value: 6, suffix: "", label: "Towers" },
    { value: 4, suffix: "", label: "Lifts in Each Tower" },
    { value: 20, suffix: "+", label: "Amenities" }
  ]
};

export const highlights = {
  bg: "https://eternia.greatvaluerealty.com/assets/images/highlights/bg.webp",
  flower1: "https://eternia.greatvaluerealty.com/assets/images/flower2.png",
  multiFlowers: "https://eternia.greatvaluerealty.com/assets/images/multi_flowers.png",
  image: "https://eternia.greatvaluerealty.com/assets/images/highlights/highlight_img-new.webp",
  items: [
    { icon: "https://eternia.greatvaluerealty.com/assets/images/highlights/icons/bed.png", text: "3 & 4 BHK Spacious Residences" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/highlights/icons/grass.png", text: "Facing a 100-Mtr Developed Green Belt" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/highlights/icons/road.png", text: "Located on a 130-Mtr Prime Road" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/highlights/icons/bulding.png", text: "6 Acres | 6 Towers | G+30 Storey Elevation" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/highlights/icons/bulding.png", text: "Skyline-Defining Symmetrical Tower Layout" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/highlights/icons/elevator.png", text: "4 Lifts per Tower for Faster Access" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/highlights/icons/living-room.png", text: "More Practical Layouts with Better Usable Area" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/highlights/icons/location.png", text: "Vastu-Compliant Architecture" }
  ]
};

export const priceList = {
  bg: "https://eternia.greatvaluerealty.com/assets/images/price_list/bg.webp",
  flower: "https://eternia.greatvaluerealty.com/assets/images/flower1.png",
  items: [
    { type: "3 BHK", area: "1932 sq. ft.", price: "\u20B9 1.81 Cr* Onwards" },
    { type: "3 BHK + STUDY", area: "2239 sq. ft.", price: "\u20B9 2.26 Cr* Onwards" },
    { type: "4 BHK + STUDY", area: "2625 sq. ft.", price: "\u20B9 2.46 Cr* Onwards" }
  ],
  note: "Inaugural Offer on the selected few units only."
};

export const amenities = {
  bg: "https://eternia.greatvaluerealty.com/assets/images/amenities/bg.png",
  slides: [
    { title: "Water Feature", tag: "Artistic Impression", image: "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/water_feature.webp" },
    { title: "Multipurpose Court", tag: "Artistic Impression", image: "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/multipurpose_court_2.webp" },
    { title: "Toddlers' Play Area", tag: "Artistic Impression", image: "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/kids-play-area.webp" },
    { title: "Swimming Pool", tag: "Artistic Impression", image: "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/swimming_pool.webp" },
    { title: "Jogging Track & Gymnasium", tag: "Artistic Impression", image: "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gym.webp" },
    { title: "Kids Play Area", tag: "Artistic Impression", image: "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/kids-play-room.webp" },
    { title: "Deck Seating", tag: "Artistic Impression", image: "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/sitting-plaza.webp" }
  ],
  list: [
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/fountain.png", label: "Water Feature" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/badminton.png", label: "Multipurpose Court" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/playground.png", label: "Toddlers' Play Area" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/swimming-pool.png", label: "Swimming Pool" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/pool-table.png", label: "Billiard Room" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/basketball.png", label: "Basketball Court" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/yoga.png", label: "Yoga, Aerobics" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/couple.png", label: "Senior Citizen Garden" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/deck-chair.png", label: "Deck Seating" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/hall.png", label: "Banquet Hall" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/stationary-bicycle.png", label: "Jogging Track & Gymnasium" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/golf-course.png", label: "Chip and Putting Greens" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/park.png", label: "Topiary Garden" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/amenities/icons/grass.png", label: "Lawn" }
  ]
};

export const location = {
  bg: "https://eternia.greatvaluerealty.com/assets/images/location_advantages/bg.webp",
  flower: "https://eternia.greatvaluerealty.com/assets/images/location_advantages/flower.png",
  multiFlowers: "https://eternia.greatvaluerealty.com/assets/images/multi_flowers.png",
  map: "https://eternia.greatvaluerealty.com/assets/images/location_advantages/map-updated.jpg",
  advantages: [
    { icon: "https://eternia.greatvaluerealty.com/assets/images/location_advantages/icons/road.png", text: "130 Mtr Wide Main Road Frontage" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/location_advantages/icons/grass.png", text: "100 Mtr Fully Developed Green Belt View" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/location_advantages/icons/save-forest.png", text: "Non-Congested but Centrally Connected" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/location_advantages/icons/subway.png", text: "Close to Schools, Metro, Malls, and Hospitals" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/location_advantages/icons/road.png", text: "Smooth Access to Major Expressways" },
    { icon: "https://eternia.greatvaluerealty.com/assets/images/location_advantages/icons/subway.png", text: "Proposed Metro Station in Close Proximity" }
  ]
};

export const floorPlans = {
  bg: "https://eternia.greatvaluerealty.com/assets/images/plans/bg.webp",
  flower: "https://eternia.greatvaluerealty.com/assets/images/plans/flower.png",
  tabs: [
    { label: "Master Plan", image: "https://eternia.greatvaluerealty.com/assets/images/plans/master-plan.webp" },
    { label: "3 BHK Plan", image: "https://eternia.greatvaluerealty.com/assets/images/plans/3bhk.webp" },
    { label: "3 BHK + Study", image: "https://eternia.greatvaluerealty.com/assets/images/plans/3bhk+study.webp" },
    { label: "4 BHK + Study", image: "https://eternia.greatvaluerealty.com/assets/images/plans/4bhk+study.webp" }
  ]
};

export const gallery = {
  bg: "https://eternia.greatvaluerealty.com/assets/images/gallery/bg.webp",
  flower: "https://eternia.greatvaluerealty.com/assets/images/gallery/flower.png",
  multiFlowers: "https://eternia.greatvaluerealty.com/assets/images/multi_flowers.png",
  images: [
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-13-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-14-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-15-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-1-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-2-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-3-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-4-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-5-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-6-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-7-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-8-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-9-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gallery-img-new-10-zoom.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/gym.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/kids-play-area.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/kids-play-room.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/multipurpose_court_2.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/sitting-plaza.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/swimming_pool.webp",
    "https://eternia.greatvaluerealty.com/assets/images/gallery/new-images/water_feature.webp"
  ]
};

export const contact = {
  bg: "https://eternia.greatvaluerealty.com/assets/images/contact-us/bg.webp",
  flower: "https://eternia.greatvaluerealty.com/assets/images/contact-us/flower.png"
};

export const footer = {
  bg: "https://eternia.greatvaluerealty.com/assets/images/footer/bg.webp",
  flower: "https://eternia.greatvaluerealty.com/assets/images/footer/flower.png",
  greatValue: "https://eternia.greatvaluerealty.com/assets/images/footer/great_value.png",
  yatharth: "https://eternia.greatvaluerealty.com/assets/images/footer/yatharth.png",
  nbcc: "https://eternia.greatvaluerealty.com/assets/images/footer/nbcc.png",
  aspire: "https://eternia.greatvaluerealty.com/assets/images/footer/aspire.png",
  greatValueAbout: "Founded in 1970, Great Value Realty (GVR) began in glassware and packaging, later expanding into food processing, tech solutions, and real estate. Known for trust and innovation, GVR has led impactful initiatives like E-Gram Samiti and E-Land Records. Its real estate ventures, including Great Value Mall and residential projects like Sharanam and Vilasa, reflect a commitment to quality living. Today, GVR continues to drive progress through strategic partnerships and forward-thinking solutions across industries.",
  yatharthAbout: "At Sanskar Realty, we believe that every home is more than just four walls\u2014it is a foundation for dreams, growth, and togetherness. With a commitment to integrity, trust, and innovation, we have been shaping inspiring living spaces that bring comfort, convenience, and value to our customers. Guided by our core values of transparency, quality, and customer-first service, Sanskar Realty has earned a reputation for delivering residential and commercial projects that combine modern architecture with sustainable design.",
  disclaimer: "Authorised marketing partner for Aspire Dream Valley III, managed by NBCC on behalf of the Hon\u2019ble Supreme Court-appointed Court Receiver. | *T&C Apply"
};
